import { useState, useMemo } from "react";
import { Modal, Button, Form, ListGroup } from "react-bootstrap";
import { FaSync } from "react-icons/fa";

const SUBTYPE_LABELS = {
    alta_nuevo: "Alta nueva",
    cambio_comercializador: "Cambio de comercializador",
    cambio_comerc_titular: "Cambio de comercializador y titular",
    cambio_comercializador_potencia: "Cambio de comercializador y potencia",
    cambio_comerc_titular_potencia: "Cambio comercializador, titular y potencia",
    cambio_comercializador_autoconsumo: "Cambio de comercializador y autoconsumo",
    cambio_comerc_titular_autoconsumo: "Cambio comercializador, titular y autoconsumo",
    cambio_comerc_potencia_autoconsumo: "Cambio comercializador, potencia y autoconsumo",
    cambio_completo: "Cambio completo (comercializador, titular, potencia y autoconsumo)",
};

export default function RelanzarOfertaModal({
    show,
    onHide,
    allowedSubtypes = [],
    onConfirm, // (selectedSubtype) => Promise<void> | void
}) {
    const [selectedSubtype, setSelectedSubtype] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const optionsWithLabels = useMemo(() => {
        return allowedSubtypes.map((subtype) => ({
            value: subtype,
            label: SUBTYPE_LABELS[subtype] || subtype,
        }));
    }, [allowedSubtypes]);

    const handleClose = () => {
        setSelectedSubtype("");
        setError("");
        onHide();
    };

    const handleConfirm = async () => {
        setError("");
        if (!selectedSubtype) {
            setError("Selecciona un subtipo para continuar.");
            return;
        }
        try {
            setLoading(true);
            await onConfirm(selectedSubtype);
            handleClose();
        } catch (e) {
            setError(e?.message || "Error al relanzar la oferta.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered contentClassName="border-0 rounded-4 shadow-lg" size="lg">
            <Modal.Header className="bg-white border-bottom-0" closeButton>
                <Modal.Title className="fw-bold text-primary d-flex align-items-center gap-2">
                    <FaSync /> Relanzar oferta
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-4">
                <Form>
                    <Form.Label className="mb-3 fw-bold text-muted small text-uppercase">
                        Selecciona el nuevo tipo de oferta
                    </Form.Label>

                    <ListGroup className="border-0">
                        {optionsWithLabels.map((option) => (
                            <ListGroup.Item
                                key={option.value}
                                className={`border-0 rounded-3 mb-2 p-3 cursor-pointer transition ${selectedSubtype === option.value
                                        ? "bg-primary-light border-primary-light"
                                        : "bg-light border-light"
                                    }`}
                                onClick={() => setSelectedSubtype(option.value)}
                                style={{ cursor: "pointer" }}
                            >
                                <Form.Check
                                    type="radio"
                                    id={`subtype-${option.value}`}
                                    name="subtype-selection"
                                    label={option.label}
                                    checked={selectedSubtype === option.value}
                                    onChange={() => setSelectedSubtype(option.value)}
                                    className={selectedSubtype === option.value ? "fw-bold text-dark" : "text-muted"}
                                />
                            </ListGroup.Item>
                        ))}
                    </ListGroup>

                    {error && (
                        <div className="alert alert-danger mt-3 mb-0" role="alert">
                            {error}
                        </div>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-light border-top">
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleConfirm} disabled={!selectedSubtype || loading}>
                    {loading ? "Procesando..." : "Relanzar"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
